import { PrismicConfiguration } from '@segurosvoluntarios_vel/commons-services';
import { environment } from 'src/environments/environment';

export const config: PrismicConfiguration = {
  apiEndpoint: environment.prismicApi,
  accessToken: environment.prismicToken,
  linkResolver() {
    return '/';
  },
  ref: environment.prismicRef,
};
